import React, { useState } from 'react';
import { fetchApplyNowTracking } from 'externals/_services/tracking.service';
import {
  plantMetadataInLocalStorageAndReturnTransferUrl,
  setPartnerNameAndImageWithId,
  convertProps,
} from 'partial/OfferManager/holder/genericOfferLogic';
import {
  CLICK_APPLY,
  SEEN_OFFER,
} from 'externals/_tracking/types/eventTypes.constants';
import { useLogger } from 'hook/error.hook';
import VisibilitySensor from 'react-visibility-sensor';
import useTrackingMetadata from 'externals/_tracking/useTrackingMetadata';
import { getFullAttributes } from 'helpers/tracking.helpers';
import { wrapService } from 'actions/service_wrapper.actions';
import { useDispatch } from 'react-redux';

const a_fetchApplyNowTracking = wrapService(fetchApplyNowTracking, {
  name: 'dr_fetchApplyNowTracking',
});

const resolveProviderLogo = provider => {
  switch (provider) {
    case 'ClearOne':
      return 'https://csesamesecure.s3.amazonaws.com/images/logo-clearone.png';
    case 'Freedom Debt Relief':
      return 'https://csesamesecure.s3.amazonaws.com/images/logo-freedomfinancial.png';
    case 'Resolve':
      return 'https://csesamesecure.s3.amazonaws.com/images/logo-resolve.png';
    default:
      return null;
  }
};
const DebtReliefOfferHolder = props => {
  const logger = useLogger({
    name: 'DebtReliefOfferHolder',
  });
  const dispatch = useDispatch();
  let pagePosition = props.pagePosition;
  const modulePosition = props.modulePosition;
  const provider = props.offerMetadata.name;
  const offerModulePosition = props.offerModulePosition;
  const [isSeenTriggered, setIsSeenTriggered] = useState(false);
  const trackingManager = useTrackingMetadata();
  const { pageNameMeta } = trackingManager;

  let trackingAttributes = getFullAttributes({
    pagePosition: pagePosition,
    modulePosition: modulePosition,
    offerMetadata: props.offerMetadata,
    position: offerModulePosition,
    extraAttributes: {
      'Page Name': pageNameMeta,
    },
  });

  const defaultEventHandler = (name, attributes = {}) => {
    const fullAttributes = Object.assign({}, trackingAttributes, attributes);
    props.eventHandler(name, fullAttributes);
  };

  const onApplyClick = e => {
    e.preventDefault();
    const imageLink = resolveProviderLogo(provider);
    const id = setPartnerNameAndImageWithId(provider, imageLink);
    let windowReference = window.open();
    dispatch(
      a_fetchApplyNowTracking(props.offerMetadata.linkUrl, {
        props: convertProps(trackingAttributes),
      }),
    )
      .then(trackingMetadata => {
        defaultEventHandler(CLICK_APPLY, {
          'Click Type': 'Apply',
          'Click ID': trackingMetadata.clickId,
          // temp solution till slapi ticket is fixed
          'Product Key': provider.toLowerCase(),
        });
        const transferUrl = plantMetadataInLocalStorageAndReturnTransferUrl(
          trackingMetadata.partnerUrl,
          id,
        );
        windowReference.location = transferUrl;
      })
      .catch(err => {
        logger.showError('A problem happened while Transferring', err.message);
        logger.reportAPIError(err);
        windowReference.close();
      });
  };

  const onVisibilityChange = isVisible => {
    if (isVisible === true && !isSeenTriggered) {
      defaultEventHandler(SEEN_OFFER, {});
      setIsSeenTriggered(true);
    }
  };

  return (
    <VisibilitySensor onChange={onVisibilityChange}>
      <props.debtReliefTemplate
        {...props}
        clickApplyHandler={onApplyClick}
        provider={provider}
        unsecuredDebt={props.unsecuredDebt}
        seenPixel={
          <VisibilitySensor onChange={onVisibilityChange}>
            <div className="invisible-pixel" />
          </VisibilitySensor>
        }
      />
    </VisibilitySensor>
  );
};

export default DebtReliefOfferHolder;
